/*
    This script creates a function that enhances and replaces the redux connect 
    function. Using connect and the other functionailty of redux, we map the 
    authenticated CRUD functions to each component invoking them to curry the
    Authorization token ensuring every request is authenticated. We also map the
    openModal function to every component ensuring that every component has 
    access to the standardised modal component.
*/

import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import mapToState from "../../utils/reduxRouter/mapToState"
import mapToDispatch from "../../utils/reduxRouter/mapToDispatch"
import mergeProps from "../../utils/reduxRouter/merge"

const connector = ({ mapState, mapDispatch, component }) =>
  withRouter(
    connect(
      mapToState(mapState),
      mapToDispatch(mapDispatch),
      mergeProps
    )(component)
  )

const enrichStateMapping =
  ({ enrichingState, inheritedFunctions }) =>
  (state, ownProps) => {
    const mapState = {}

    return {
      ...mapState,
      ...enrichingState(state, ownProps),
      ...inheritedFunctions,
    }
  }

const enrichDispatchMapping = (enrichingDispatch) => (dispatch, ownProps) => ({
  ...enrichingDispatch(dispatch, ownProps),
})

export default ({
  component,
  enrichingState,
  enrichingDispatch,
  inheritedFunctions,
}) =>
  connector({
    mapState: enrichStateMapping({ enrichingState, inheritedFunctions }),
    mapDispatch: enrichDispatchMapping(enrichingDispatch),
    component,
  })
